// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3TUt6","label":"Section_label__3VR5Z","contentWrap":"Section_contentWrap__34-_k","footer":"Section_footer__1ZO1y","footerInner":"Section_footerInner__1J51T"};